import './main.scss';
import User from './modules/firebase/Auth';
var user = new User();
